import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import AddEditModal from './addEditModal.vue';
import Setting from './setting.vue';
import { yesNoStatus } from '@/enum';
import { namespace } from 'vuex-class';
var User = namespace('user');

var WrapperProductListPage = function (_super) {
  __extends(WrapperProductListPage, _super);

  function WrapperProductListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.addEditVisible = false;
    _this.rowSelection = {};
    _this.settingVisible = false;
    _this.yesNoStatus = yesNoStatus;
    _this.rowData = {};
    _this.packageProductEnum = [];
    _this.packageOptionEnum = [];
    _this.packageReqAllEnum = [];
    _this.skuWrapperSourceEnum = [];
    _this.packageSelectEnum = [];
    _this.packageTimeTypeEnum = [];
    _this.needPackageEnum = [];
    _this.searchData = _this.initSearchData();
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  Object.defineProperty(WrapperProductListPage.prototype, "isProductPrivateWrapper", {
    get: function get() {
      return this.customerInfo.is_product_private_wrapper;
    },
    enumerable: false,
    configurable: true
  });

  WrapperProductListPage.prototype.created = function () {
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: this.onSelectChange
    };
    this.setColumns();
    this.queryList();
    this.queryWarehouseList();
  };

  WrapperProductListPage.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('商品编码'),
      dataIndex: 'product_sku',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('谷仓商品条码'),
      dataIndex: 'product_barcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('商品名称'),
      dataIndex: 'product_name_cn',
      filterEmpty: true
    }, {
      title: this.t('SKU包装属性'),
      dataIndex: 'sku_wrapper_type_text',
      filterEmpty: true
    }, {
      title: this.t('适用仓库（区域）'),
      name: 'warehouse_code',
      scopedSlots: {
        customRender: 'warehouse_code'
      }
    }, {
      title: this.t('是否需要包材'),
      dataIndex: 'need_package_text',
      filterEmpty: true
    }, {
      title: this.t('包材归属'),
      dataIndex: 'sku_wrapper_source_text',
      filterEmpty: true
    }, {
      title: this.t('包材选择方'),
      dataIndex: 'package_select_text',
      filterEmpty: true
    }, {
      title: this.t('包材要求'),
      dataIndex: 'package_req_text',
      filterEmpty: true
    }, {
      title: this.t('包材编码'),
      scopedSlots: {
        customRender: 'package_code'
      },
      filterEmpty: true
    }, {
      title: this.t('包材名称'),
      dataIndex: 'package_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      width: 200,
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      width: 150,
      title: this.t('操作'),
      name: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  WrapperProductListPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.time_start = '';
      this.searchData.time_end = '';
    }
  };

  WrapperProductListPage.prototype.getWarehouseName = function (record) {
    var _a;

    var warehouseCode = record.warehouse_code;
    var warehouseName = (_a = record.warehouse_name) !== null && _a !== void 0 ? _a : '';
    return this.$util.getWarehouseCodeWithName(warehouseCode, warehouseName);
  };

  WrapperProductListPage.prototype.initSearchData = function () {
    return {
      product_code_field: 'product_sku',
      product_code_value: '',
      warehouse_code: undefined,
      package_option: 'package_code',
      package_option_value: '',
      need_package: undefined,
      package_req: undefined,
      package_select: undefined,
      sku_wrapper_source: undefined,
      time_type: this.$enum.warehouse.WrapperTimeType.UPDATE_TIME,
      time_start: '',
      time_end: '',
      page_index: 1,
      page_size: 200
    };
  };

  WrapperProductListPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = this.rowSelection.selectedRowKeys = selectedRowKeys;
  };

  WrapperProductListPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.selectedList = this.rowSelection.selectedRowKeys = [];
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = null;
            return [4, this.$api.wrapper.queryProductWrapperList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  WrapperProductListPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList({
              is_append_remark: false
            })];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  WrapperProductListPage.prototype.deleteProductWrapper = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.deleteProductWrapper(param)];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  WrapperProductListPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryList();
  };

  WrapperProductListPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryList();
  };

  WrapperProductListPage.prototype.initPage = function () {
    this.selectedList = this.rowSelection.selectedRowKeys = [];
    this.searchData.page_index = 1;
  };

  WrapperProductListPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryList();
  };

  WrapperProductListPage.prototype.handleAddBulk = function () {
    this.$router.push({
      name: 'WrapperProductUpdatePage'
    });
  };

  WrapperProductListPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryList();
    });
  };

  WrapperProductListPage.prototype.handleUpdateSuccess = function () {
    this.queryList();
  };

  WrapperProductListPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData = {
                id_list: this.selectedList
              };
            }

            return [4, this.$api.wrapper.excelProductWrapper(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  WrapperProductListPage.prototype.handleDelete = function (record) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('删除提示'),
      content: this.t('请确认是否删除该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.deleteProductWrapper({
                  id_list: [record.id]
                })];

              case 1:
                _a.sent();

                this.queryList();
                return [2];
            }
          });
        });
      }
    });
  };

  WrapperProductListPage.prototype.handleDeleteBulk = function () {
    var _this = this;

    if (!this.selectedList.length) {
      this.$message.warn(this.t('请先选择删除项'));
      return;
    }

    var modal = this.$confirm({
      title: this.t('删除提示'),
      content: this.t('请确认是否删除选中记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.deleteProductWrapper({
                  id_list: this.selectedList
                })];

              case 1:
                _a.sent();

                this.queryList();
                return [2];
            }
          });
        });
      }
    });
  };

  WrapperProductListPage.prototype.handleAdd = function () {
    this.rowData.title = this.t('新增包材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = null;
    this.addEditVisible = true;
  };

  WrapperProductListPage.prototype.handleEdit = function (record) {
    this.rowData.title = this.t('编辑商品包材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = record;
    this.addEditVisible = true;
  };

  WrapperProductListPage.prototype.handleSetting = function () {
    this.rowData.title = this.t('商品包材设置');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = {};
    this.settingVisible = true;
  };

  __decorate([enumData('Wrapper/ProductWrapperQueryFieldEnum')], WrapperProductListPage.prototype, "packageProductEnum", void 0);

  __decorate([enumData('Wrapper/PackageOptionEnum')], WrapperProductListPage.prototype, "packageOptionEnum", void 0);

  __decorate([enumData('Wrapper/PackageReqAllEnum')], WrapperProductListPage.prototype, "packageReqAllEnum", void 0);

  __decorate([enumData('Wrapper/SkuWrapperSourceEnum')], WrapperProductListPage.prototype, "skuWrapperSourceEnum", void 0);

  __decorate([enumData('Wrapper/PackageSelectEnum')], WrapperProductListPage.prototype, "packageSelectEnum", void 0);

  __decorate([enumData('Wrapper/PackageTimeTypeEnum')], WrapperProductListPage.prototype, "packageTimeTypeEnum", void 0);

  __decorate([enumData('Wrapper/NeedPackageEnum')], WrapperProductListPage.prototype, "needPackageEnum", void 0);

  __decorate([User.State('customerInfo')], WrapperProductListPage.prototype, "customerInfo", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], WrapperProductListPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('productWrapperList')], WrapperProductListPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], WrapperProductListPage.prototype, "queryList", null);

  WrapperProductListPage = __decorate([Component({
    components: {
      AddEditModal: AddEditModal,
      Setting: Setting
    }
  })], WrapperProductListPage);
  return WrapperProductListPage;
}(Vue);

export default WrapperProductListPage;